module.exports = __webpack_public_path__ + "static/media/faq-plus.5722759c.svg";